import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    transferId: z.string(),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
